import { Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function MissedCalls() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate();

    const {
        selectedDates,
        setSingleSelectedHotels,
        selectedHotels,
        kioskSelection,
    } = useContext(SettingContext);

    const hotel_ids = selectedHotels;

    const [start_date, end_date] = selectedDates;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "missed_calls_counts",
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        call_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: missedCallsStatus,
        data: missedCallsRes,
        refetch: fetchMissedCallSCount,
    } = useQuery(
        "missedCallsTable",
        async () => {
            return await HTTP("/dashboard/getMissedCallsDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchMissedCallSCount();
    }, []);

    useEffect(() => {
        fetchMissedCallSCount();
    }, [formData]);

    useEffect(() => {
        setFormData({
            ...formData,
            call_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (missedCallsStatus === "success") {
            const { data: callsAnsweredData, total } = missedCallsRes;
            setTotalRecords(total);
            setTableData(callsAnsweredData);
        }
    }, [missedCallsStatus, missedCallsRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }
        const updatedFormData = { ...formData, ...others };
        updatedFormData.all_selected =
            updatedFormData.hotel_ids.length > 0 ? false : true;
        updatedFormData.start_date = formatDate(updatedFormData.start_date);
        updatedFormData.end_date = formatDate(updatedFormData.end_date);
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            render: (text, record) => (
                <span
                    onClick={getHotelWiseData}
                    id={record.hotel_id}
                    data-hotelname={text}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Calls Missed",
            dataIndex: "missed_calls_counts",
            key: "missed_calls_counts",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "missed_calls_counts"
                    ? sortedInfo.order
                    : null,
        },
    ];

    function getHotelWiseData(e) {
        const hotel_id = e.currentTarget.getAttribute("id");
        const hotel_name = e.currentTarget.getAttribute("data-hotelname");
        setSingleSelectedHotels(`${hotel_name}#${hotel_id}`);
        return navigate(`/call-missed-details/${hotel_id}`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                {missedCallsStatus === "loading" ||
                missedCallsStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                    />
                )}
            </Card>
        </Card>
    );
}

export { MissedCalls };
